module.exports = __webpack_public_path__ + "img/altheute.c09db62a.jpg";